import React, { FC, memo } from 'react';
import NextLink from 'next/link';
import Grid from '@material-ui/core/Grid';

import { Title, Link, Icon } from './downloadFile.styles';
import { DownloadFileProps, DownloadFileData } from './downloadFile.types';
import DownloadIcon from '@keaze/web/public/svg/download.svg';

type RenderFile = (file: DownloadFileData, key: number) => JSX.Element;

const renderFile: RenderFile = ({ title, link }, key) => (
  <Link key={key}>
    <NextLink href={link} prefetch={false} passHref>
      <a target="_blank">
        <Title>{title}</Title>
        <Icon>
          <DownloadIcon />
        </Icon>
      </a>
    </NextLink>
  </Link>
);

export const DownloadFile: FC<DownloadFileProps> = memo(({ data }) => (
  <Grid container direction="column">
    {data.map(renderFile)}
  </Grid>
));
